import { useContext, useEffect } from "react";
import { ForecastAccuracyControlComponent } from "./control_component";
import { DiffParams, SalesMeasure, Segmentation } from "../diff_params";
// import { RunTriggerContext } from "../../../contexts/run_trigger/context";
import { ApiContext } from "../../../contexts/api/context";
import {
  useGetMyCustomerQuery,
  useGetMyRunComparisonRunIdsQuery,
} from "../../../services/api/__generated__/backend_gateway-types";
import { WorkflowsContext } from "../../../contexts/workflows/context";

export const ForecastAccuracyControlContainer = (props: {
  diffParams: DiffParams;
  updateDiffParams: (params: DiffParams) => void;
}) => {
  const { diffParams, updateDiffParams } = props;
  // const { runLogs, isLogsLoading } = useContext(RunTriggerContext);
  const { allRuns, isLoading } = useContext(WorkflowsContext);

  const { apiService } = useContext(ApiContext);
  const {
    data: runIdsData,
    loading: runIdsLoading,
    error: runIdsError,
  } = useGetMyRunComparisonRunIdsQuery({
    client: apiService.getClient(),
  });

  const {
    data: customerData,
    loading: customerLoading,
    error: customerError,
  } = useGetMyCustomerQuery({
    client: apiService.getClient(),
  });

  const maxId: number | null = runIdsData?.getMyRunComparisonRunIds
    ? Math.max(...runIdsData.getMyRunComparisonRunIds)
    : null;
  // const actualsRun = maxId
  //   ? runLogs.find((rl) => rl.id === maxId) || null
  //   : null;
  const actualsRun = maxId
    ? allRuns.find((r) => r.oldRunId === maxId) || null
    : null;

  const updateParams = (params: DiffParams) => {
    updateDiffParams({
      ...params,
      salesMeasure: params.salesMeasure || SalesMeasure.QUANTITY,
    });
  };

  const updateRuns = (params: DiffParams) => {
    // const nextForecastRun =
    //   runLogs.find(
    //     (rl) =>
    //       params.forecastEngineRunId === (rl.id === null ? "" : `${rl.id}`)
    //   ) || null;
    const nextForecastRun =
      allRuns.find(
        (r) =>
          params.forecastEngineRunId ===
          (r.oldRunId === null ? "" : `${r.oldRunId}`)
      ) || null;
    updateDiffParams({
      ...params,
      ...((nextForecastRun?.createdAt || null) !== null &&
        (actualsRun?.createdAt || null) !== null && {
          minDate: new Date(nextForecastRun!.createdAt!),
          maxDate: new Date(actualsRun!.createdAt!),
        }),
      salesMeasure: params.salesMeasure || SalesMeasure.QUANTITY,
      segmentation: params.segmentation || Segmentation.PRODUCT_TYPE,
    });
  };

  useEffect(() => {
    if (diffParams.actualsEngineRunId === null && maxId !== null) {
      updateDiffParams({
        ...diffParams,
        actualsEngineRunId: `${maxId}`,
      });
    }
  }, [diffParams, maxId, updateDiffParams]);

  if (runIdsError) {
    console.error(
      "ForecastAccuracyControlContainer: useGetMyLockedDemandOutputRunIdsQuery fetch error",
      runIdsError
    );
  }

  if (customerError) {
    console.error(
      "ForecastAccuracyControlContainer: useGetMyCustomerQuery fetch error",
      customerError
    );
  }

  return (
    <ForecastAccuracyControlComponent
      diffParams={diffParams}
      updateDiffParams={updateParams}
      updateRuns={updateRuns}
      loading={isLoading || runIdsLoading || customerLoading}
      error={null}
      runs={allRuns.filter(
        (r) =>
          r.oldRunId &&
          runIdsData?.getMyRunComparisonRunIds?.includes(r.oldRunId) &&
          r.oldRunId !== maxId
      )}
      actualsRun={actualsRun}
      hasProductCategory={
        customerData?.getMyCustomer?.features?.SkuHierarchyProductCategory ||
        false
      }
      hasProductType={
        customerData?.getMyCustomer?.features?.SkuHierarchyProductType || false
      }
      hasProductFamily={
        customerData?.getMyCustomer?.features?.SkuHierarchyProductFamily ||
        false
      }
      hasProductTitle={
        customerData?.getMyCustomer?.features?.SkuHierarchyProductTitle || false
      }
    />
  );
};
